import React from 'react';
import LoginForm from '../components/Login/LoginForm';


const Login = () => {

  return (
    <>
      <div className="flex items-center justify-center text-[#454545] font-['Roboto',sans-serif] h-screen bg-gradient-to-br from-[#1569AB] via-[#1569AB] to-[#1E8C45]">
        <LoginForm />
      </div>


    </>
  )
}

export default Login




// import React, { useEffect, useState } from "react";
// import { Card } from "antd";
// import zerodha from "../assets/images/zerodha.png";
// import grow from "../assets/images/grow.png";
// import upstock from "../assets/images/upstock.png";
// import other from "../assets/images/other.png";
// // import { useNavigate, useParams } from "react-router-dom";
// // import { AUTHENTICATED_ROUTES } from "../constants/routeConstants";
// // import { useDispatch } from "react-redux";
// // import { postKiteData, postLoginData } from "../store/Slice/AuthSlice";
// // import axios from "axios";

// const Login = () => {


//   const login = async () => {
  
//     const params = new URLSearchParams(window.location.search);
//     const clientId = "u72wg8ivj1l9xksf";
//     const request_token = params.has("request_token");
//     if (!request_token) {
//       const authUrl = `https://kite.trade/connect/login?v=3&api_key=${clientId}`;
//       window.location.href = authUrl;
//     }
  
//   };


//   return (
//     <div className="login">
//       <div className="login__header"></div>
//       <div className="login__body">
//         <p>
//           Welcome to <span>foxtox</span>
//         </p>

//         <div className="sub_text">
//           <p>Login to your Broker account</p>
//           <p>Please select to your Broker account to proceed further.</p>
//         </div>

//         <div className="login__cards">
//           <Card className="card" onClick={login}>
//             <div className="card_img">
//               <img src={zerodha} alt="img" />
//               <p>Zerodha</p>
//             </div>
//           </Card>
//           <Card className="card">
//             <div className="card_img">
//               <img src={grow} alt="img" />
//               <p>Groww</p>
//             </div>
//           </Card>
//           <Card className="card">
//             <div className="card_img">
//               <img src={upstock} alt="img" />
//               <p>Upstox</p>
//             </div>
//           </Card>{" "}
//           <Card className="card">
//             <div className="card_img">
//               <img src={other} alt="img" />
//               <p>Other</p>
//             </div>
//           </Card>
//         </div>
//         <div className="login_issues">
//           <p>Having login issues?</p>
//           <p>Click here</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;
